// 261015 E1-P1 — khối GẬP "Thông báo & điểm (n)": phần KHÔNG phải lỗi (điểm giám khảo · thông báo · chưa kiểm · cần chạy lại).
// Màu trung tính (không đỏ/vàng), KHÔNG có nút trợ lý — C1: chip/nút chỉ dành cho lỗi thật. n = 0 ⇒ không render.
import React from 'react';
import { Collapse, Tag, Typography } from 'antd';
import { gateLabel, humanizeCodes, kindLabel } from '../adaptationUtils';
import type { OtherIssueKind } from '../adaptationUtils';

const { Text } = Typography;

export interface OtherIssueRow {
  gate: string; message?: string; kind: OtherIssueKind; count?: number;
  /** Ngoại lệ có chủ đích (261015 F67 giữ): dòng điểm CRITIC ở ⑤ vẫn có nút "Phương án". Mọi hàng khác không có. */
  action?: React.ReactNode;
  /** 261015 P2b-1: `message` đã là câu hoàn chỉnh (vd dòng "Đã chấp nhận": id cao trào + lý do) — KHÔNG qua `humanizeCodes` (nó đổi `beat_x` thành "một nhịp"). */
  plain?: boolean;
}

interface Props {
  rows: ReadonlyArray<OtherIssueRow>;
  /** Cho phép nhãn tuỳ biến (vd ⑤ ưu tiên `scenePlanGateLabel`). */
  labelOf?: (gate: string) => string;
  nameOf?: (id: string) => string;
}

const OtherIssuesBlock: React.FC<Props> = ({ rows, labelOf, nameOf }) => {
  if (!rows.length) return null;
  const total = rows.reduce((n, r) => n + (r.count ?? 1), 0);
  return (
    <Collapse
      size="small" ghost data-testid="other-issues-block" style={{ marginBottom: 8 }}
      items={[{
        key: 'others',
        label: <Text type="secondary">{`Thông báo & điểm (${total})`}</Text>,
        children: (
          <div role="list" aria-label="Thông báo và điểm — không phải lỗi">
            {rows.map((r, i) => (
              <div key={`${r.gate}-${i}`} role="listitem" style={{ fontSize: 13, padding: '2px 0' }}>
                <Tag bordered={false} style={{ marginRight: 6 }}>{kindLabel(r.kind)}</Tag>
                <Text strong type="secondary">{labelOf ? labelOf(r.gate) : gateLabel(r.gate)}</Text>
                {r.count && r.count > 1 ? <Text type="secondary">{` ×${r.count}`}</Text> : null}
                {r.message ? <Text type="secondary">{` — ${r.plain ? r.message : humanizeCodes(r.message, nameOf)}`}</Text> : null}
                {r.action ? <span style={{ marginLeft: 8 }}>{r.action}</span> : null}
              </div>
            ))}
          </div>
        ),
      }]}
    />
  );
};

export default OtherIssuesBlock;
